document.addEventListener('DOMContentLoaded', function () {

    const stepsSwiper = new Swiper('.steps_swiper-js', {
        loop: true,                  // ← infini
        loopedSlides: 5,             // nb de clones de chaque côté (adapter si besoin)
        slidesPerView: 3,
        spaceBetween: 10,
        centeredSlides: true,
        slideToClickedSlide: true,
        navigation: {
            nextEl: ".steps_next",
            prevEl: ".steps_prev",
        },
        breakpoints: {
            480:  { slidesPerView: 4,  spaceBetween: 10 },
            768:  { slidesPerView: 5,  spaceBetween: 15 },
            1024: { slidesPerView: 7,  spaceBetween: 20 },
            1280: { slidesPerView: 9,  spaceBetween: 20 },
        },
    });

    const contentSwiper = new Swiper('.steps_content_swiper-js', {
        loop: false,           // ← le contenu lui ne boucle pas
        slidesPerView: 1,
        autoHeight: true,
        allowTouchMove: false,
    });

    let lastSyncedIndex = -1;

    function syncContent(realIndex) {
        if (realIndex === lastSyncedIndex) return;
        lastSyncedIndex = realIndex;
        contentSwiper.slideTo(realIndex);
        updateActiveButton(realIndex);
    }

    function updateActiveButton(realIndex) {
        stepsSwiper.slides.forEach(slide => {
            slide.classList.remove('swiper-slide-button-active');
        });
        // Cibler tous les slides (vrais + clones) qui pointent vers ce realIndex
        stepsSwiper.slides.forEach(slide => {
            if (parseInt(slide.dataset.stepIndex) === realIndex) {
                slide.classList.add('swiper-slide-button-active');
            }
        });
    }

    stepsSwiper.on('slideChange', function () {
        syncContent(stepsSwiper.realIndex);  // ← realIndex et non activeIndex
    });

    stepsSwiper.on('click', function (swiper) {
        if (swiper.clickedSlide === undefined) return;
        const realIndex = parseInt(swiper.clickedSlide.dataset.stepIndex);
        if (isNaN(realIndex)) return;
        syncContent(realIndex);
    });

    // Init
    updateActiveButton(0);
});